var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.length > 0)?_c('div',{ref:"slider",attrs:{"data-slider":""}},[_vm._t("head"),_vm._v(" "),_c('div',{staticClass:"swiper-wrapper"},[_vm._l((_vm.items),function(item,index){return [_vm._t("body",null,{"item":item,"index":index})]})],2),_vm._v(" "),_vm._t("navigation")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }